// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skip[data-v-577be980]{margin-top:28px;font-style:normal;font-weight:400;font-size:16px;line-height:22px}.skip .skip-link[data-v-577be980]{color:var(--q4s-accent)}", ""]);
// Exports
module.exports = exports;
